<template>
  <FormContainer withoutDivider>
    <template #title>Diplôme ou titre visé par le salarié(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_53"
          class="col-36"
          v-model="typeQualificationModel"
          :required="meta.formation?.typeQualification?.$status === PropertyStatus.Required"
          :alert-label="meta.formation?.typeQualification?.$messageErreurDirty!"
          label="Type de qualification visée"
          :readonly
          :items="lovTypeQualification"
          :disabled="estDossier"
        />
        <WrapperInput
          v-if="meta.formation?.conventionCollective?.$status !== PropertyStatus.NotPresent"
          id="field_54"
          label="IDCC et nom de la convention collective"
          class="col-26 col-sm-36"
          v-model="conventionCollectiveModel"
          :required="meta.formation?.conventionCollective?.$status === PropertyStatus.Required"
          :alert-label="meta.formation?.conventionCollective?.$messageErreurDirty!"
          :readonly
          deletable
          :disabled="estDossier"
        />
        <WrapperInput
          v-else
          id="field_54"
          label="IDCC et nom de la convention collective"
          class="col-26 col-sm-36"
          disabled
        />
        <WrapperInput
          v-if="meta.formation?.niveau?.$status !== PropertyStatus.NotPresent"
          id="field_55"
          class="col-4 col-sm-36"
          v-model="niveauModel"
          :required="meta.formation?.niveau?.$status === PropertyStatus.Required"
          :alert-label="meta.formation?.niveau?.$messageErreurDirty!"
          label="Niveau"
          :readonly
          deletable
          :disabled="estDossier"
        />
        <WrapperInput
          v-else
          id="field_55"
          class="col-4 col-sm-36"
          label="Niveau"
          disabled
        />
        <WrapperInput
          v-if="meta.formation?.coefficient?.$status !== PropertyStatus.NotPresent"
          id="field_56"
          class="col-6 col-sm-36"
          v-model="coefficientModel"
          label="Coefficient"
          :required="meta.formation?.coefficient?.$status === PropertyStatus.Required"
          :alert-label="meta.formation?.coefficient?.$messageErreurDirty!"
          :readonly
          deletable
          :disabled="estDossier"
        />
        <WrapperInputNumber
          v-else
          id="field_56"
          class="col-6 col-sm-36"
          label="Coefficient"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInputNumber
          v-if="meta.formation?.nombreCCP?.$status !== PropertyStatus.NotPresent"
          id="field_57"
          v-model="nombreCCPModel"
          :decimal="0"
          label="Nombre CCP"
          class="col-6 col-sm-36"
          :required="meta.formation?.nombreCCP?.$status === PropertyStatus.Required"
          :alert-label="meta.formation?.nombreCCP?.$messageErreurDirty!"
          :readonly
          deletable
          :disabled="estDossier"
        />
        <WrapperInputNumber
          v-else
          id="field_57"
          :decimal="0"
          label="Nombre CCP"
          class="col-6 col-sm-36"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          v-if="estReservation && meta.formation?.typeReferentielFormation?.$status !== PropertyStatus.NotPresent"
          id="field_58"
          class="col-12 col-md-18 col-sm-36"
          label="Rechercher votre formation par"
          v-model="typeReferentielFormationModel"
          :items="typeReferentielFormationItems"
          :required="meta.formation?.typeReferentielFormation?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.typeReferentielFormation?.$messageErreurDirty!"
          :readonly
          :disabled="!estTypeReferentielFormationActif"
        />
         <WrapperToggleSwitch
          id="field_58"
          class="col-12 col-md-18 col-sm-36"
          label="Rechercher votre formation par"
          :items="typeReferentielFormationItems"
          :alertLabel="meta.formation?.typeReferentielFormation?.$messageErreurDirty!"
          disabled
         />

      </div>
      <div class="form__bloc">
        <WrapperAutocomplete
          v-if="meta.formation?.rncp?.$status !== PropertyStatus.NotPresent"
          id="field_59"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="rncpModel"
          :search="searchRNCP"
          :required="meta.formation?.rncp?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.rncp?.$messageErreurDirty"
          label="Code RNCP"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="3"
          placeholder="Ex: boulangerie ou 39257"
          :readonly
          :disabled="estDossier"
        />
        <BasicText
          v-if="meta.formation?.rncp?.$status !== PropertyStatus.NotPresent && model?.statut !== 0 as any"
          class="col-36"
          size="body-m"
          font-style="italic"
        >
          Si vous ne connaissez pas votre code "RNCP" ou votre code "Répertoire Spécifique", merci de vous référer au
          Site
          <BasicLink
            label="France compétences."
            @link-click="redirectExterne('https://www.francecompetences.fr/recherche-resultats')"
          />
        </BasicText>
        <WrapperAutocomplete
          v-if="meta.formation?.formacode?.$status !== PropertyStatus.NotPresent"
          id="field_60"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="formacodeModel"
          :search="searchFormacode"
          :required="meta.formation?.formacode?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.formacode?.$messageErreurDirty"
          label="Formacode"
          class="col-18 col-sm-36"
          :search-min-length="3"
          placeholder="EX : boulangerie ou 45022108"
          :readonly
          :disabled="estDossier"
        />
        <BasicText
          v-if="meta.formation?.formacode?.$status !== PropertyStatus.NotPresent && model?.statut !== 0 as any"
          class="col-36"
          size="body-m"
          font-style="italic"
        >
          Si vous ne connaissez pas votre Domaine de formation / Formacode, merci de vous référer au
          <BasicLink
            label="Site Centre Inffo"
            @link-click="redirectExterne('https://www.centre-inffo.fr/offre-formation-produits-services/le-formacode-v14')"
          />
        </BasicText>
      </div>
      <div class="form__bloc">
        <WrapperAutocomplete
          v-if="meta.formation?.rncp?.$status === PropertyStatus.NotPresent"
          id="field_59"
          label="Code RNCP"
          hint="Code ou intitulé"
          :search="searchRNCP"
          class="col-18 col-sm-36"
          placeholder="Ex: boulangerie ou 39257"
          disabled
        />
        <WrapperAutocomplete
          v-if="meta.formation?.formacode?.$status === PropertyStatus.NotPresent"
          id="field_60"
          :search="searchFormacode"
          label="Formacode"
          class="col-18 col-sm-36"
          placeholder="EX : boulangerie ou 45022108"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperAutocomplete
          id="field_61"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="nsfModel"
          :search="searchNsfSelonTypeQualification"
          :required="meta.formation?.nsf?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.nsf?.$messageErreurDirty"
          label="Spécialité (NSF)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="estNsfSurRncp || estNsfSurFormacode ? 0 : 3"
          placeholder="Ex: Commercialisation de produits alimentaires ou 221w"
          :readonly
          :disabled="estDossier || meta.formation?.nsf?.$status === PropertyStatus.NotPresent || !estNsfActif"
        />
        <WrapperInput
          id="field_62"
          class="col-18 col-sm-36"
          v-model="intituleModel"
          hint="50 caractères maximum"
          :required="meta.formation?.intitule?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.intitule?.$messageErreurDirty!"
          label="Intitulé précis"
          deletable
          :readonly
          :maxlength="50"
          :disabled="estDossier || meta.formation?.intitule?.$status === PropertyStatus.NotPresent || !estIntituleActif"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_63"
          label="Diplôme ou titre visé"
          class="col-18 col-sm-36"
          v-model="diplomeOuTitreViseModel"
          :items="lov.Diplome"
          :required="meta.formation?.diplomeOuTitreVise?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.diplomeOuTitreVise?.$messageErreurDirty!!"
          key-id="code"
          key-label="intitule"
          :readonly
        />
        <WrapperDropdown
          v-if="estDossier"
          id="field_64"
          label="Objectif général de la formation"
          help="Cet élément décrit les objectifs généraux de la formation. Ils ne doivent pas être confondus avec les objectifs pédagogiques."
          class="col-18 col-sm-36"
          v-model="objectifGeneralFormationModel"
          :items="lov.ObjectifGeneralFormation"
          :required="meta.formation?.objectifGeneralFormation?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.objectifGeneralFormation?.$messageErreurDirty!!"
          key-id="code"
          key-label="intitule"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInputNumber
          id="field_65"
          v-model="dureeTotaleModel"
          label="Durée totale de la formation externe"
          :required="meta.formation?.dureeTotale?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dureeTotale?.$messageErreurDirty!"
          class="col-9 col-md-18 col-sm-36"
          :decimal="2"
          deletable
        />
        <WrapperInputNumber
          id="field_66"
          v-model="dureeTotaleBilansModel"
          label="Durée totale des bilans"
          :required="meta.formation?.dureeTotaleBilans?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dureeTotaleBilans?.$messageErreurDirty!"
          class="col-9 col-md-18 col-sm-36"
          :decimal="2"
          deletable
        />
        <WrapperInputNumber
          v-if="estReservation && meta.mission?.duree?.$status !== PropertyStatus.NotPresent"
          id="field_99"
          v-model="dureeMissionModel"
          label="Durée mission"
          hint="Durée de la mission en heures"
          :required="meta.mission?.duree?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.duree?.$messageErreurDirty!"
          :decimal="0"
          deletable
          :readonly
          class="col-9 col-md-18 col-sm-36"
        />
        <WrapperInputNumber
          v-if="meta.formation?.dureeMinimumMission?.$status !== PropertyStatus.NotPresent"
          id="field_67"
          :model-value="model?.formation?.dureeMinimumMission"
          label="Durée minimum de mission"
          :help="
          model?.sousDispositif === 'CIPI'
            ? 'La durée de mission doit être minimum de 70h.'
            : 'La durée de mission doit être égale au ⅓ du temps de la durée de formation saisie et réalisée dans les 3 mois suivants la date de fin de formation.'
        "
          :required="meta.formation?.dureeMinimumMission?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dureeMinimumMission?.$messageErreurDirty!"
          class="col-9 col-md-18 col-sm-36"
          :decimal="0"
          :readonly
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { FormacodeDTO, LovItemDTO, RncpDto } from '@/features/api/extranet/dto/Lov'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { TypeReferentielFormation } from '@/features/domaine/types/opco'
  import { type TypeQualification } from '@/features/domaine/types/opco/Demande/CXPI'
  import { typeReferentielFormationItems } from '@/features/interface/demande/cpro/dropdown-items'
  import {
    typeQualificationCDPIItems,
    typeQualificationCIPIItems,
  } from '@/features/interface/demande/cxpi/dropdown-items.ts'
  import { CXPI_ACTIONS } from '@/features/interface/demande/cxpi/useDemandeCXPIActions.ts'
  import { DEMANDE_STORE, FormContainer } from '@/features/interface/demande/shared'
  import type { SearchNsf } from '@/features/services/demande/DemandeAllService.types'
  import { objectExtract, truncate } from '@/features/shared/tools'
  import { storeToRefs } from 'pinia'
  import { computed, inject } from 'vue'
  import { redirectExterne } from '@/features/shared/tools/url'

  const { searchRNCP, searchFormacode, searchNsf } = inject(CXPI_ACTIONS)!
  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { setupFieldWithKey, setupFieldWithOptions } = store
  const { model, meta, readonly, lov, estReservation, estDossier } = storeToRefs(store)

  const getLabel = function (value: LovItemDTO<string>) {
    return `${value.code} - ${value.intitule}`
  }

  // const typeQualificationModel = setupFieldWithKey<TypeQualification>('formation.typeQualification')

  const typeQualificationModel = setupFieldWithOptions<TypeQualification | null>({
    getValue: () => model.value?.formation!.typeQualification ?? null,
    setPatch: (patch, value) => {
      patch.formation!.typeQualification = value

      let typeReferentielFormation : TypeReferentielFormation  | null = null

      // on force le RNCP
      if (['CQPRncp'].includes(value!)) {
        typeReferentielFormation = 'Rncp'
      }
      // on force le FormaCode
      else if (
        [
          'AttestationCapacite',
          'CertificatCompetencePro',
          'CertificatClea',
          'BlocClea',
          'CertificationRS',
          'QualificationCC',
        ].includes(value!)
      ) {
        typeReferentielFormation = 'Formacode'
      }
      patch.formation!.typeReferentielFormation = typeReferentielFormation


      // reset de la saisie
      patch.formation!.rncp = null
      patch.formation!.formacode = null
      patch.formation!.nsf = null
      patch.formation!.intitule = null
    },
  })

  const conventionCollectiveModel = setupFieldWithKey<string>('formation.conventionCollective', true)
  const niveauModel = setupFieldWithKey<string>('formation.niveau', true)
  const coefficientModel = setupFieldWithKey<string>('formation.coefficient', true)
  const nombreCCPModel = setupFieldWithKey<number>('formation.nombreCCP', true)
  const dureeTotaleModel = setupFieldWithKey<number>('formation.dureeTotale', true)
  const dureeTotaleBilansModel = setupFieldWithKey<number>('formation.dureeTotaleBilans', true)
  const intituleModel = setupFieldWithKey<string>('formation.intitule', true)
  const dureeMissionModel = setupFieldWithKey<number>('mission.duree', true)

  const estIntituleActif = computed(() => {
    if (!typeReferentielFormationModel.value) return false
    if (typeReferentielFormationModel.value === 'Rncp') return false

    return true
  })


  const diplomeOuTitreViseModel = setupFieldWithKey<string>('formation.diplomeOuTitreVise', false)
  const objectifGeneralFormationModel = setupFieldWithKey<string>('formation.objectifGeneralFormation', true)

  const rncpModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: () => model.value?.formation?.rncp ?? null,
    setPatch: (patch, value) => {
      patch.formation!.rncp = value ? objectExtract(value, ['code', 'intitule']) : null
      if (value?.code) {
        patch.formation!.intitule = truncate(value?.intitule,50)
        const rncp = value as RncpDto
        if (rncp.nsf?.length === 1) {
          patch.formation!.nsf = rncp.nsf.at(0)
        }
      } else {
        patch.formation!.intitule = null
      }
    },
  })

  const formacodeModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: (model) => model.formation?.formacode ?? null,
    setPatch: (patch, value) => {
      patch.formation!.formacode = value ? objectExtract(value, ['code', 'intitule']) : null
      if (value?.code) {
        const formacode = value as FormacodeDTO
        if (formacode.nsf?.length === 1) {
          patch.formation!.nsf = formacode.nsf.at(0)
        }
      }
    },
  })

  const typeReferentielFormationModel = setupFieldWithOptions<TypeReferentielFormation | null>({
    getValue: () => model.value?.formation?.typeReferentielFormation ?? null,
    setPatch(patch, value) {
      patch.formation!.typeReferentielFormation = value

      patch.formation!.rncp = null
      patch.formation!.formacode = null
      patch.formation!.nsf = null
      patch.formation!.intitule = null
    },
  })

  const estNsfSurRncp = computed(() => typeReferentielFormationModel.value === 'Rncp')
  const estNsfSurFormacode = computed(() => typeReferentielFormationModel.value === 'Formacode')

  const estNsfActif = computed(() => {
    if (estNsfSurRncp.value) return !!rncpModel.value?.code
    if (estNsfSurFormacode.value) return !!formacodeModel.value?.code
    return false
  })

  const estTypeReferentielFormationActif = computed(() => {
      return  ![
          'AttestationCapacite',
          'CertificatCompetencePro',
          'CertificatClea',
          'BlocClea',
          'CertificationRS',
          'QualificationCC',
          'CQPRncp'
        ].includes(model.value!.formation!.typeQualification!) || estDossier.value

  })

  const searchNsfSelonTypeQualification = (search: string) => {
    const query: SearchNsf = { search }
    if (estNsfSurRncp.value) {
      query.codeRNCP = rncpModel.value?.code
    } else if (estNsfSurFormacode.value) {
      query.codeFormacode = formacodeModel.value?.code
    }
    return searchNsf(query)
  }

  const nsfModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: (model) => model.formation?.nsf ?? null,
    setPatch: (patch, value) => {
      patch.formation!.nsf = value ? objectExtract(value, ['code', 'intitule']) : null
    },
  })

  const lovTypeQualification = computed(() =>
    model.value?.sousDispositif === 'CIPI' ? typeQualificationCIPIItems : typeQualificationCDPIItems,
  )
</script>
